import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { FeatureFlags } from '@janeapp/feature-flags-client/react';
import App from './App.tsx';
import { setupStore } from './state/store.ts';
import { configureSentry, configureDatadogRum } from './utilities';

configureSentry();
configureDatadogRum();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <FeatureFlags.Provider>
    <Provider store={setupStore()}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </FeatureFlags.Provider>
);
